module.exports = __webpack_public_path__ + "static/media/IBT.1099f277.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/IBT.jpg
// module id = 1752
// module chunks = 1